import React, { Component } from 'react';
import emailIcon from './Email.png';
import Inquiry from './Inquiry';
import './guitar.css';
import PropTypes from 'prop-types';

class Guitar extends Component {
  state = { inquiryShown: false };

  inquiryToggle = () => {
    this.setState({ inquiryShown: !this.state.inquiryShown });
  };

  render() {
    const guitar = this.props.guitar;
    const inquiry = this.state.inquiryShown ? (
      <Inquiry guitar={guitar} />
    ) : null;
    return (
      <div>
        <div className="row mt-2">
          <h5 className="col-md-12">{guitar.brand}</h5>
        </div>
        <div className="row">
          <h3 className="col-md-12">{guitar.title}</h3>
        </div>
        <div className="row">
          <div className="col-md-7">
            <img src={`${guitar.photo}`} alt="Guitar" height="300" />
          </div>
          <div className="col-md-5">
            <p className="price">${guitar.price}</p>
            <p>{guitar.description}</p>
            <img
              className="email-icon"
              src={emailIcon}
              height="50"
              alt="inquiry"
              onClick={this.inquiryToggle}
            />
            {inquiry}
          </div>
        </div>
      </div>
    );
  }
}

Guitar.propTypes = { guitar: PropTypes.object.isRequired };
export default Guitar;



// WEBPACK FOOTER //
// ./src/guitar/index.js